import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { ProductCarousel } from './ProductCarousel';
import { CHECKOUT_URL, trackInitiateCheckout } from './constants';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-150" data-mp="4lqkazhutj53">
      <div className="absolute inset-x-0 top-0 h-[420px] bg-cream-dark/60 -z-10" data-id="element-151" data-mp="4jvv38zjv4v7" />
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[720px] h-[720px] rounded-full bg-gold/10 blur-[120px] -z-10" data-id="element-152" data-mp="128pgl94mwp2g" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-153" data-mp="sbb5lp1hcshj">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-154" data-mp="sd4bh249r8oh">
          <div className="inline-block px-3 py-1 rounded-full border border-gold bg-cream-light text-burgundy font-semibold text-[10px] sm:text-sm tracking-widest uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-155" data-mp="3d2tpjcx5eqg4">
            🎓 Hip Hop Dance Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold uppercase leading-tight mb-4 sm:mb-6 text-ink" data-id="element-156" data-mp="3o6khfnpfum7r">
            Solve an entire year of hip hop dance classes{' '}
            <span className="brush-accent" data-id="element-157" data-mp="3e84odf6up2vm">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[280px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-158" data-mp="30h9d5w8vq9ov">
          <div className="absolute inset-0 bg-burgundy/10 blur-[70px] rounded-full" data-id="element-159" data-mp="2vietyt702j48" />
          <img src="https://cdn.magicpatterns.com/uploads/q1AXhAWHGR29igoE6EbP15/Diseno_sin_titulo_(72).png" alt="Hip Hop Dance Instructor Ready — 6-in-1 complete teaching system box set" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" data-mp="2hjf6hov84a9n" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-161" data-mp="nat65811aej4">
          <p className="text-sm sm:text-lg md:text-xl text-ink-soft leading-snug max-w-3xl mx-auto mb-5 sm:mb-7" data-id="element-162" data-mp="ddnhs7jt11ml">
            100 ready-to-teach hip hop classes with foundations, grooves,
            footwork, freestyle, choreography and performance guidance.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-163" data-mp="15zzw9g45q8ey">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-164" data-mp="11151dfsx0teh">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>
          </div>

          <ProductCarousel data-id="element-165" data-mp="1x9b0knlp8d68" />

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-ink-muted" data-id="element-166" data-mp="1xa44lgt9woko">
            <div className="flex items-center gap-1.5" data-id="element-167" data-mp="21bxwp0pekk98">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-168" data-mp="269zjnwpy93pz" />
              <span data-id="element-169" data-mp="268ofhvsldtyc">Premium 6-in-1 Teaching System</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-170" data-mp="2b1hkmkrz34ay">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-171" data-mp="2g02l8lb4zpzx" />
              <span data-id="element-172" data-mp="2g1wv94kvdxp8">5 strategic bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173" data-mp="2kxudjgfp1e4n">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-174" data-mp="2p0h7pnzu7b50" />
              <span data-id="element-175" data-mp="2p1a5w0kqcsbj">Immediate access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}